export default {
  smiles: [
    {
      name: 'smile1',
      text: `<img src="https://emojio.ru/images/apple-m/1f600.png" style="width: 20px">`,
      url: 'https://emojio.ru/images/apple-m/1f600.png',
    },
    {
      name: 'smile2',
      text: `<img src="https://emojio.ru/images/apple-m/1f603.png" style="width: 20px">`,
      url: 'https://emojio.ru/images/apple-m/1f603.png',
    },
    {
      name: 'smile3',
      text: `<img src="https://emojio.ru/images/apple-m/1f604.png" style="width: 20px">`,
      url: 'https://emojio.ru/images/apple-m/1f604.png',
    },
    {
      name: 'smile4',
      text: `<img src="https://emojio.ru/images/apple-m/1f601.png" style="width: 20px">`,
      url: 'https://emojio.ru/images/apple-m/1f601.png',
    },
    {
      name: 'smile5',
      text: `<img src="https://emojio.ru/images/apple-m/1f602.png" style="width: 20px">`,
      url: 'https://emojio.ru/images/apple-m/1f602.png',
    },
  ],
}
